export const geoUtils = {
    isPointInQuadrant,intersect
};

function intersect(bl,tr,BL,TR){
   // var points=[];
    var p1={x:bl.x,y:bl.y};
    var p2={x:bl.x,y:tr.y};
    var p3={x:tr.x,y:bl.y};
    var p4={x:tr.x,y:tr.y};
    
    if (isPointInQuadrant(p1,BL,TR)){
        return true;
    }
    if (isPointInQuadrant(p2,BL,TR)){
        return true;
    }
    if (isPointInQuadrant(p3,BL,TR)){
        return true;
    }
    if (isPointInQuadrant(p4,BL,TR)){
        return true;
    }
    //altro quadrante
    var P1={x:BL.x,y:BL.y};
    var P2={x:BL.x,y:TR.y};
    var P3={x:TR.x,y:BL.y};
    var P4={x:TR.x,y:TR.y};
    if (isPointInQuadrant(P1,bl,tr)){
        return true;
    }
    if (isPointInQuadrant(P2,bl,tr)){
        return true;
    }
    if (isPointInQuadrant(P3,bl,tr)){
        return true;
    }
    if (isPointInQuadrant(P4,bl,tr)){
        return true;
    }
   return false;

    
}

function isPointInQuadrant(point,BL,TR){

  if (point.x>=BL.x && point.x<=TR.x && point.y>=BL.y && point.y<=TR.y){
    return true;
  }
  return false;
}
   


